import { createStore, applyMiddleware } from 'redux';
import {
  createAuthMiddleware,
  getInitialAuthState,
  storage } from 'redux-simple-auth';
import { composeWithDevTools } from 'redux-devtools-extension/logOnlyInProduction';
import rootReducer from '../reducers';
import userAuthenticator from '../authenticators/user';
import thunk from 'redux-thunk';

const authMiddleware = createAuthMiddleware({
  authenticator: userAuthenticator,
  authorize: ({ token }, header) => {
    if (token) {
      header('Authorization', `Bearer ${token}`)
    }
  },
  refresh: response => {
    const token = response.headers.get('x-access-token')
    return token ? { token } : null
  }
});

export default createStore(
  rootReducer,
  composeWithDevTools(
    applyMiddleware(authMiddleware),
    getInitialAuthState({ storage })
  )
);



// WEBPACK FOOTER //
// ./src/config/store.js